var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyDataSystems = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 11C36.3954 11 35.5 11.8954 35.5 13V27C35.5 28.1046 36.3954 29 37.5 29H51.5C52.6046 29 53.5 28.1046 53.5 27V13C53.5 11.8954 52.6046 11 51.5 11H37.5ZM38.5 14V26H50.5V14H38.5Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 35C12.3954 35 11.5 35.8954 11.5 37V51C11.5 52.1046 12.3954 53 13.5 53H27.5C28.6046 53 29.5 52.1046 29.5 51V37C29.5 35.8954 28.6046 35 27.5 35H13.5ZM14.5 38V50H26.5V38H14.5Z",
    fill: "#071A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 13C11.5 11.8954 12.3954 11 13.5 11H27.5C28.6046 11 29.5 11.8954 29.5 13V27C29.5 28.1046 28.6046 29 27.5 29H13.5C12.3954 29 11.5 28.1046 11.5 27V13ZM14.5 26V14H26.5V26H14.5Z",
    fill: "#071A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 35.5C45.3284 35.5 46 36.1716 46 37V42.5H51.4996L51.4999 45.5H46V50.9996L43 50.9999L43 45.5H37.5C36.6716 45.5 36 44.8284 36 44C36 43.1716 36.6716 42.5 37.5 42.5H43V37C43 36.1716 43.6716 35.5 44.5 35.5Z",
    fill: "#071A24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50.9996C46 51.828 45.3284 52.5 44.5 52.5C43.6716 52.5 43 51.8283 43 50.9999L46 50.9996Z",
    fill: "#071A24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4996 42.5C52.328 42.5 53 43.1716 53 44C53 44.8284 52.3283 45.5 51.4999 45.5L51.4996 42.5Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyDataSystems);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty_data_systems.a717639c61539931b332257f3ec830cf.svg";